import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import Seo from '../../components/Seo';

const PartnerDashboard = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const stats = [
        { label: t('partners.dashboard.totalReferrals'), value: '0', icon: 'fas fa-users' },
        { label: t('partners.dashboard.activeDeals'), value: '0', icon: 'fas fa-handshake' },
        { label: t('partners.dashboard.earnings'), value: '$0', icon: 'fas fa-dollar-sign' },
        { label: t('partners.dashboard.conversionRate'), value: '0%', icon: 'fas fa-chart-pie' },
    ];

    return (
        <Fragment>
            <Seo title={`${t('partners.dashboard.title')} | OrbitroniX`} description={t('partners.dashboard.title')} url={`/${lang}/partner/dashboard`} />
            <Layout>
                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="page-title pt-150 pos-rel bg_img">
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }} className="page-title-box">
                                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="sub-title">
                                            📊 {t('partners.title')}
                                        </motion.span>
                                        <motion.h2 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="title">
                                            {t('partners.dashboard.title')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }} className="pb-85 cp-det-bg">
                    <div className="container">
                        <div className="row mb-40">
                            {stats.map((s, i) => (
                                <div className="col-lg-3 col-md-6 mb-30" key={i}>
                                    <div style={{ background: '#0c1130', border: '1px solid #1e115b', borderRadius: '12px', padding: '30px', textAlign: 'center' }}>
                                        <i className={`${s.icon} mb-3`} style={{ fontSize: '32px', color: '#6c5ce7' }}></i>
                                        <h3 className="text-white mb-1">{s.value}</h3>
                                        <p className="text-white-50 mb-0" style={{ fontSize: '14px' }}>{s.label}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-details-widget" style={{ padding: '50px' }}>
                                    <h3 className="text-white mb-30">{t('partners.dashboard.recentActivity')}</h3>
                                    <p className="text-white-50">{t('partners.dashboard.noActivity')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default PartnerDashboard;
